import React, { Component, PropTypes } from 'react';

import { uniqueId } from 'lodash';

import css from './switch.scss';

export default class InputSwitch extends Component {
	static propTypes = {
		name: PropTypes.string.isRequired,
		on: PropTypes.string,
		off: PropTypes.string,
		onChange: PropTypes.func,
		allowToggleOff: PropTypes.bool,
	};

	static defaultProps = {
		error: undefined,
		value: 0,
		allowToggleOff: true,
		onChange: function() {},
	};

	constructor(props) {
		super();

		this.valid = (typeof props.error === 'undefined') ? true : !props.error;
		this.value = props.value ? 1 : 0;
		this.unique = uniqueId();

		this.state = {
			value: this.value,
			valid: this.valid,
		};
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			this.props !== nextProps ||
			this.state.valid !== nextState.valid ||
			this.state.value !== nextState.value
		);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.value !== this.state.value) {
			this.value = nextProps.value ? 1 : 0;
			this.setState({
				...this.state,
				value: nextProps.value,
			});
		}
	}

	render() {
		let labelClassName = 'custom-switch';
		let inputClassName = 'custom-switch__input';
		let onButtonClass = 'custom-switch__button button';
		let offButtonClass = 'custom-switch__button button';

		if (this.props.className) {
			labelClassName += ' ' + this.props.className;
		}

		if (this.state.value) {
			onButtonClass += ' button--dark';
		} else {
			offButtonClass += ' button--dark';
		}

		return (
			<div className={labelClassName}>
					{/* output input type text with all the given props as attributes */}
					<input
						ref='input'
						type='checkbox'
						id={this.props.name + this.unique}
						name={this.props.name}
						className={inputClassName}
						checked={this.state.value}
						readOnly={true}
					/>

					<div className={onButtonClass} onClick={this.toggleOn.bind(this)}>
						{this.props.on}
					</div>
					<div className={offButtonClass} onClick={(e) => this.props.allowToggleOff && this.toggleOff(e)}>
						{this.props.off}
					</div>
			</div>
		);
	}

	toggleOn(e) {
		this.value = 1;
		this.setState({ ...this.state, value: true });

		this.props.onChange(this.value);
	}

	toggleOff(e) {
		this.value = 0;
		this.setState({ ...this.state, value: false });

		this.props.onChange(this.value);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/form/input/switch.js
 **/